__webpack_require__.p = "/reports-remove-details-columns-max-width/system-email-templates/";